/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebu_Stl_StlInputs */



/**
* | output |
* | --- |
* | "EBU STL (.stl)" |
*
* @param {Ebu_Stl_StlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ebu_stl_stl = /** @type {((inputs?: Ebu_Stl_StlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebu_Stl_StlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("EBU STL (.stl)")
	if (locale === "de") return /** @type {LocalizedString} */ ("EBU STL (.stl)")
	if (locale === "it") return /** @type {LocalizedString} */ ("EBU STL (.stl)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("EBU STL (.stl)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo STL de la UER (.stl)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("EBU STL (.stl)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("EBU STL (.stl)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईबीयू एसटीएल (.stl)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("EBU STL (.stl)")
	return /** @type {LocalizedString} */ ("EBU STL (.stl)")
});